'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.end_user_edit', {
        url: 'user_edit/:id',
        template: '<end-user-edit></end-user-edit>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/end_user/edit/end_user_edit.routes.js